import React, { useState } from 'react'
import { Button } from '../common/forms'
import server from '../api/server'

const Support = () => {
  const [values, setValues] = useState({message: ''})
  const [submitting, setSubmitting]   = useState(false)
  const [valid, setValid]             = useState(false)
  const [showBugForm, setShowBugForm] = useState(false)
  const [showSuccess, setShowSucess]  = useState(false)

  const _handler = (e) => {
    const { value, name } = e.currentTarget
    const nextValues = {...values}
    nextValues[name] = value
    _validate(nextValues)
    setValues(nextValues)
  }

  const _validate = (values) => {
    let noErrors = Object.keys(values).every((key) => (
      values[key] == null || values[key].match(/^ *$/) == null
    ))
    setValid(noErrors)
  }

  const _submitHandler = (e) => {
    if (e) {
      e.preventDefault()
      setSubmitting(true)
    }

    let url = `${window.location.protocol}//${window.location.host}/support`

    let body = {
      body: values.message
    }

    return server.post(url, { support: body })
      .then(() => {
        setValues({message: ''})
        setSubmitting(false)
        setShowBugForm(false)
        setShowSucess(true)
      })
  }

  const _displaySubmitSuccessNotification = () => {
    if (!showSuccess) return
    return (
      <div>
        <h2 style={{paddingLeft: '1.5rem'}}>Bug Report Created</h2>
        <p>Thank you are your feedback! You can open another bug report <a onClick={() => { setShowBugForm(true); setShowSucess(false)} }>here</a></p>
      </div>
    )
  }

  const _handleBugClick = () => setShowBugForm(!showBugForm)

  const _displayBugForm = () => {
    return (
      <div className="bug-report-form">
        <h2>Submit a Bug Report</h2>
        {/* <p>Is something not working right? Report it here.</p> */}
        <form onSubmit={_submitHandler}>
          <div>
            <textarea
              className   = "message"
              type        = "text"
              name        = "message"
              value       = {values.message}
              onChange    = {_handler}
              required    = {true}
              placeholder = "Type here and let us know what's not working right."
            />
          </div>
          <Button
            className     = "secondary"
            clickHandler  = {_submitHandler}
            aria-label    = "Submit Form"
            disabled      = {submitting || !valid}
          >
            Submit Report
          </Button>
          <Button
            className     = "primary basic"
            clickHandler  = {_handleBugClick}
            aria-label    = "Cancel Form"
          >
            Cancel
          </Button>
        </form>
      </div>
    )
  }

  const _openZohoChat = () => {
    try {
      // eslint-disable-next-line
      if($zoho) {
        // eslint-disable-next-line
        $zoho.salesiq.floatwindow.visible('show')
      }
    } catch(e) {
      // do nothing
    }
  }

  return (
    <div className="tile main-support-section">
      <div className="columns icon-groups">
        <div className="column">
          <div className="icon-group phone">
            <a href="tel:+1-877-218-8232">
              <i className="fas fa-mobile-alt" />
              <em>
                <span className="hide-on-mobile">1-877-218-8232</span>
                <span className="show-on-mobile">Call us</span></em>
            </a>
          </div>
          <p className="details"><a href="tel:+1-877-218-8232">Call us</a> Monday-Sunday from 9 AM to 5 PM</p>
        </div>
        <div className="column">
          <div className="icon-group email">
            <a href="mailto:help@vacationoffer.com">
              <i className="fas fa-envelope" />
              <em>Email Us</em>
            </a>
          </div>
          <p className="details">
            Send us an <a href="mailto:help@vacationoffer.com">email</a><span className="hide-on-mobile">
              &nbsp;at <a href="mailto:help@vacationoffer.com">help@vacationoffer.com</a>
            </span>.</p>
        </div>
        <div className="column">
          <div className="icon-group chat">
            <a onClick={_openZohoChat}>
              <i className="fas fa-comment-dots" />
              <em>Live Chat</em>
            </a>
          </div>
          <p className="details">
            <a onClick={_openZohoChat}>Chat with a Travel Agent</a> during business hours.</p>
        </div>

        <div className="column">
          <div className="icon-group bug">
            <a onClick={_handleBugClick}>
              <i className="fas fa-bug" />
              <em>Bug Report</em>
            </a>
          </div>
          <p className="details">Is something not working right? <a onClick={_handleBugClick}>Click here</a> to report it.</p>
        </div>
      </div>
      {/* {_displayForm()} */}
      { showBugForm && _displayBugForm() }
      { showSuccess && _displaySubmitSuccessNotification()}
    </div>
  )
}

export default Support
